@theme inline {
  --color-background-default: var(--background-default);
  --color-background-subtle: var(--background-subtle);
  --color-surface-default: var(--surface-default);
  --color-surface-raised: var(--surface-raised);
  --color-surface-sunken: var(--surface-sunken);
  --color-text-default: var(--text-default);
  --color-text-muted: var(--text-muted);
  --color-text-subtle: var(--text-subtle);
  --color-text-inverse: var(--text-inverse);
  --color-text-link: var(--text-link);
  --color-border-default: var(--border-default);
  --color-border-subtle: var(--border-subtle);
  --color-border-strong: var(--border-strong);
  --color-action-default: var(--action-default);
  --color-action-hover: var(--action-hover);
  --color-action-subtle: var(--action-subtle);
  --color-success-surface: var(--success-surface);
  --color-success-text: var(--success-text);
  --color-success-border: var(--success-border);
  --color-success-solid: var(--success-solid);
  --color-warning-surface: var(--warning-surface);
  --color-warning-text: var(--warning-text);
  --color-warning-border: var(--warning-border);
  --color-warning-solid: var(--warning-solid);
  --color-danger-surface: var(--danger-surface);
  --color-danger-text: var(--danger-text);
  --color-danger-border: var(--danger-border);
  --color-danger-solid: var(--danger-solid);
  --color-info-surface: var(--info-surface);
  --color-info-text: var(--info-text);
  --color-info-border: var(--info-border);
  --color-info-solid: var(--info-solid);
}

:root {
  --background-default: #fafafa;
  --background-subtle: #f5f5f5;
  --surface-default: #ffffff;
  --surface-raised: #ffffff;
  --surface-sunken: #f5f5f5;
  --text-default: #0e1113;
  --text-muted: #495054;
  --text-subtle: #888f92;
  --text-inverse: #ffffff;
  --text-link: #002664;
  --border-default: #dcdfe0;
  --border-subtle: #ebebeb;
  --border-strong: #888f92;
  --action-default: #002664;
  --action-hover: #001037;
  --action-subtle: #f0fbff;
  --success-surface: #eff9ed;
  --success-text: #005a02;
  --success-border: #8fc78a;
  --success-solid: #008a07;
  --warning-surface: #fff3ed;
  --warning-text: #882f03;
  --warning-border: #eea88a;
  --warning-solid: #c95000;
  --danger-surface: #fff0ef;
  --danger-text: #7c061f;
  --danger-border: #ea9294;
  --danger-solid: #b81237;
  --info-surface: #e9eef7;
  --info-text: #193366;
  --info-border: #8098c2;
  --info-solid: #2e5299;
}
